<template>
    <div>
        <div class="pac-card" id="pac-card">
            <div>
                <div id="title">
                    Rechercher un lieu
                </div>
                <div id="type-selector" class="pac-controls">
                    <input type="radio" name="type" id="changetype-all" checked="checked">
                    <label for="changetype-all">All</label>

                    <input type="radio" name="type" id="changetype-establishment">
                    <label for="changetype-establishment">
                        Établissements</label>

                    <input type="radio" name="type" id="changetype-address">
                    <label for="changetype-address">Adresses</label>

                    <input type="radio" name="type" id="changetype-geocode">
                    <label for="changetype-geocode">Geocodes</label>
                </div>
                <div id="strict-bounds-selector" class="pac-controls">
                    <input type="checkbox" id="use-strict-bounds" value="">
                    <label for="use-strict-bounds">Cite, Region</label>
                </div>
            </div>
            <div id="pac-container">
                <input id="pac-input" type="text"
                       placeholder="Enter a location">
            </div>
        </div>
        <div class="google-map" :id="mapName" style="height:600px; width:100%"></div>
        <div id="legend"></div>
        <div id="infowindow-content">
            <img src="" width="16" height="16" id="place-icon">
            <span id="place-name"  class="title"></span><br>
            <span id="place-address"></span>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'google-map',
        props: ['name',"listMarqueur"],
        data: function () {
            return {
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                mapName: this.name + "-map",
                markers: [],
                dialogPlan: false,
            }
        },
        methods:{
            geolocate(map) {
                    this.listMarqueur.forEach(projet => {
                        const marker = {
                            lat: projet.lat,
                            lng: projet.lng,
                            image: projet.urlImage,

                            lib:
                             "<img src="+projet.urlImage+" height=180px  width=290px  /><br/>"+
                            "<b  style='font-weight: bold'>Adresse: </b>" +projet.adresse +
                            " <br/><b style='font-weight: bold'>Projet: </b>" +projet.libelle +
                            " <br/><b style='font-weight: bold'>Prix du marché: </b><b style='font-weight: bold; color:blue'>" +projet.mntMarche +
                            " FCFA</b><br/><b style='font-weight: bold'>Montant total dépensé: </b><b style='font-weight: bold; color:blue'>"+projet.montantTotalDepenseNbr +
                            " FCFA</b><br/><b style='font-weight: bold'> Etat d'avancement : </b> <progress id='file' max='100' value="+projet.evolutionNbr+">"+ projet.evolutionNbr+"%</progress><b style='font-weight: bold; color:blue'>" + projet.evolutionNbr+
                            " %</b><br/><b style='font-weight: bold'>Date début: </b>" + projet.dateD+
                            " <br/><b style='font-weight: bold'> Date de fin: </b>" + projet.dateF +
                            "<br/> <b style='font-weight: bold'>Lat/Lng: </b>" +projet.lat+"/"+projet.lng ,
                            couleurMk: projet.couleurMarker,
                        }
                        this.markers.push(marker);
                    });

                    //Ajout des markers
                    this.markers.forEach((coord) => {
                        const position = new google.maps.LatLng(coord.lat, coord.lng);
                        const libelle = coord.lib
                        const marker = new google.maps.Marker({
                            position,
                            map,
                            //   icon: 'http://www.devnotebook.fr/sites/default/files/styles/media_crop/public/2017-05/marqueur_maison.png'
                            icon:{
                                path: 'M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173.004,321.035    c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C441.425,83.182,358.244,0,256,0z M256,278.719    c-51.442,0-93.292-41.851-93.292-93.293S204.559,92.134,256,92.134s93.291,41.851,93.291,93.293S307.441,278.719,256,278.719z',
                                fillColor: coord.couleurMk,
                                fillOpacity: 0.5,
                                scale: 0.04,
                                strokeColor: coord.couleurMk,
                                strokeWeight: 1
                            }
                        });
                        this.attachSecretMessage(marker, libelle);
                    });
                //chargement des marqueurs des projets
                //this.loading = true
               // let url = this.domaine + 'chantier/index'
                // this.$http.get(url).then(response => {
                //     this.loading = false
                //     this.items = response.body.chantier

                    // for (var i = 0; i < this.items.length; i++) {
                    //     const marker = {
                    //         lat: this.items[i].lat,
                    //         lng: this.items[i].lng,
                    //         lib: " <b style='font-weight: bold'>Adresse: </b>" +this.items[i].adresse +" <br/>   <b style='font-weight: bold'>Projet: </b>" +this.items[i].libelle +" <br/> <b style='font-weight: bold'>Date début: </b>" + this.items[i].dateD+" <br/><b style='font-weight: bold'> Date de fin: </b>" + this.items[i].dateF +" <br/><b style='font-weight: bold'> Etat d'avancement : </b> <b style='font-weight: bold; color:blue'>" + this.items[i].evolutionNbr+ " %</b> <br/> <b style='font-weight: bold'>Lat/Lng: </b>" +this.items[i].latitude+"/"+this.items[i].longitude ,
                    //         couleurMk: this.items[i].couleurMarker,
                    //     }
                    //     this.markers.push(marker);
                    // }

                    // //Ajout des markers
                    // this.markers.forEach((coord) => {
                    //     const position = new google.maps.LatLng(coord.lat, coord.lng);
                    //     const libelle = coord.lib
                    //     const marker = new google.maps.Marker({
                    //         position,
                    //         map,
                    //         icon:{
                    //             path: 'M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173.004,321.035    c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C441.425,83.182,358.244,0,256,0z M256,278.719    c-51.442,0-93.292-41.851-93.292-93.293S204.559,92.134,256,92.134s93.291,41.851,93.291,93.293S307.441,278.719,256,278.719z',
                    //             fillColor: coord.couleurMk,
                    //             fillOpacity: 0.5,
                    //             scale: 0.04,
                    //             strokeColor: coord.couleurMk,
                    //             strokeWeight: 1
                    //         }
                    //     });
                    //     this.attachSecretMessage(marker, libelle);
                    // });

                // }, (response)=>{
                //     this.loading = false
                //     this.$message.error('erreur lors du chargement des coordonnees des projets');
                // })
            },
            attachSecretMessage(marker, secretMessage) {
                var infowindow = new google.maps.InfoWindow({
                    content: secretMessage
                });

                marker.addListener('click', function() {
                    infowindow.open(marker.get('map'), marker);
                });
            },
            mount(){
                 const element = document.getElementById(this.mapName)
            const options = {
                zoom: 7.0,
                center: new google.maps.LatLng(6.982418, -5.327522),
                gestureHandling: 'greedy'
            }

            var newStyle =[
                {
                    "featureType": "all",
                    "elementType": "all",
                    "stylers": [
                        {
                            "invert_lightness": true
                        },
                        {
                            "saturation": "-9"
                        },
                        {
                            "lightness": "0"
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "all",
                    "stylers": [
                        {
                            "weight": "1.00"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "weight": "0.49"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "weight": "0.01"
                        },
                        {
                            "lightness": "-7"
                        },
                        {
                            "saturation": "-35"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ];

            var styles = {
        'monTheme': [
                        {
                            featureType: 'road',
                            stylers: [
                                {visibility: 'off'}
                            ]
                        },
                        {
                            featureType: 'road.arterial',
                            stylers: [
                                {visibility: 'off'}
                            ]
                        },
                        {
                            featureType: 'road.local',
                            stylers: [
                                {visibility: 'off'}
                            ]
                        },
                        {
                            featureType: 'landscape',
                            stylers: [
                                {visibility: 'off'}
                            ]
                        },
                        {
                            featureType: 'water',
                            stylers: [
                                {visibility: 'on'},
                                {lightness: -100}
                            ]
                        }
                    ]
                };

            const map = new google.maps.Map(element, options);

             map.setOptions({'styles': newStyle});
                // var styledMapType = new google.maps.StyledMapType(styles['monTheme'], {name: 'monTheme'});
                // map.setOptions(styles['monTheme'], {name: 'monTheme'});



            var iconBase = 'static/legend/';
            var iconBase_ = "http://www.devnotebook.fr/sites/default/files/styles/media_crop/public/2017-05/marqueur_maison.png";

            var icons = {
                Livre: {
                    name: 'Projet',
                    icon: iconBase + 'mkv.png'
                },
                travaux : {
                    name: 'En travaux',
                    icon: iconBase + 'mko.png'
                },
                Arrete: {
                    name: 'Arret des travaux',
                    icon: iconBase + 'mkr.png'
                }
            };

            var legend = document.getElementById('legend');

                for (var key in icons) {
                var type = icons[key];
                var name = type.name;
                var icon = type.icon;
                var div = document.createElement('div');
                div.innerHTML = '<img src="' + icon + '"> ' + name
                if(legend != null){
                    legend.appendChild(div);
                }


            }
             map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(legend);

            this.geolocate(map)

            var card = document.getElementById('pac-card');
            var input = document.getElementById('pac-input');
            var types = document.getElementById('type-selector');
            var strictBounds = document.getElementById('strict-bounds-selector');

            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);
            var autocomplete = new google.maps.places.Autocomplete(input);
            // Bind the map's bounds (viewport) property to the autocomplete object,
            // so that the autocomplete requests use the current map bounds for the
            // bounds option in the request.
            autocomplete.bindTo('bounds', map);

            // Set the data fields to return when the user selects a place.
            autocomplete.setFields(
                ['address_components', 'geometry', 'icon', 'name']);

            var infowindow = new google.maps.InfoWindow();
            var infowindowContent = document.getElementById('infowindow-content');
            infowindow.setContent(infowindowContent);
            var marker = new google.maps.Marker({
                map: map,
                anchorPoint: new google.maps.Point(0, -29)
            });

            autocomplete.addListener('place_changed', function() {
                infowindow.close();

                marker.setVisible(false);
                var place = autocomplete.getPlace();

                if (!place.geometry) {
                    // User entered the name of a Place that was not suggested and
                    // pressed the Enter key, or the Place Details request failed.
                    window.alert("No details available for input: '" + place.name + "'");
                    return;
                }

                // If the place has a geometry, then present it on a map.
                if (place.geometry.viewport) {
                    map.fitBounds(place.geometry.viewport);
                } else {
                    map.setCenter(place.geometry.location);
                    map.setZoom(17);  // Why 17? Because it looks good.
                }

                marker.setPosition(place.geometry.location);
                marker.setVisible(true);

                var address = '';
                if (place.address_components) {
                    address = [
                        (place.address_components[0] && place.address_components[0].short_name || ''),
                        (place.address_components[1] && place.address_components[1].short_name || ''),
                        (place.address_components[2] && place.address_components[2].short_name || '')
                    ].join(' ');
                }

                infowindowContent.children['place-icon'].src = place.icon;
                infowindowContent.children['place-name'].textContent =   place.name;

                infowindowContent.children['place-address'].textContent = address +" (Latitude: "+place.geometry.location.lat()+" Longitude:"+place.geometry.location.lng()+ " )"  ;
                infowindow.open(map, marker);
            });

             // Sets a listener on a radio button to change the filter type on Places
                    // Autocomplete.
                    function setupClickListener(id, types) {
                        var radioButton = document.getElementById(id);
                        radioButton.addEventListener('click', function() {
                            autocomplete.setTypes(types);
                        });
                    }

                if(legend != null){

                    setupClickListener('changetype-all', []);
                    setupClickListener('changetype-address', ['address']);
                    setupClickListener('changetype-establishment', ['establishment']);
                    setupClickListener('changetype-geocode', ['geocode']);
                    }
                    if ( document.getElementById('use-strict-bounds') != null){
                         document.getElementById('use-strict-bounds')
                        .addEventListener('click', function() {
                            autocomplete.setOptions({strictBounds: this.checked});
                        });
                    }

                }

        },
        watch:
        {
            listMarqueur: function () {
                 this.mount();
            }
        },

        mounted: function () {
            //this.mount();

        }
    };
</script>


<style scoped>
    .google-map {
        width: 100%;
        height: 800px;
        margin: 0 auto;
        background: gray;
    }

    #legend {
        font-family: Arial, sans-serif;
        background: #fff;
        padding: 10px;
        margin: 10px;
        border: 3px solid #000;
    }
    #legend h3 {
        margin-top: 0;
    }
    #legend img {
        vertical-align: middle;
    }

    #description {
        font-family: Roboto;
        font-size: 15px;
        font-weight: 300;
    }

    #infowindow-content .title {
        font-weight: bold;
    }

    /*#infowindow-content {*/
        /*display: none;*/
    /*}*/

    #map #infowindow-content {
        display: inline;
    }

    .pac-card {
        margin: 10px 10px 0 0;
        border-radius: 2px 0 0 2px;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        outline: none;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
        background-color: #fff;
        font-family: Roboto;
    }

    #pac-container {
        padding-bottom: 12px;
        margin-right: 12px;
    }

    .pac-controls {
        display: inline-block;
        padding: 5px 11px;
    }

    .pac-controls label {
        font-family: Roboto;
        font-size: 13px;
        font-weight: 300;
    }

    #pac-input {
        background-color: #fff;
        font-family: Roboto;
        font-size: 15px;
        font-weight: 300;
        margin-left: 12px;
        padding: 0 11px 0 13px;
        text-overflow: ellipsis;
        width: 400px;
    }

    #pac-input:focus {
        border-color: #4d90fe;
    }

    #title {
        color: #fff;
        background-color: #4d90fe;
        font-size: 25px;
        font-weight: 500;
        padding: 0px 12px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/map/GoogleMap.vue